export const FilterSvg = () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 14H7.7L5 11V6L0 1V0H14V1L9 6V14Z" fill="white" />
</svg>
